import { Injectable } from '@angular/core';

import type { IBlockConfig } from '@core/models/marketplace.model';

export interface Cb2CompiledRuntimeSources {
  blocks: IBlockConfig[];
  paramValues: Record<string, unknown>;
  paramCatalog: Record<string, { type?: string }>;
}

/**
 * Keeps the last CB2 compiled runtime payload (unresolved blocks + param map)
 * so contextual `$cases` (e.g. shop branches) can be re-evaluated when the
 * active page shop or viewport context changes.
 */
@Injectable({ providedIn: 'root' })
export class Cb2CompiledRuntimeStateService {
  private sources: Cb2CompiledRuntimeSources | null = null;

  setSources(sources: Cb2CompiledRuntimeSources | null): void {
    this.sources = sources;
  }

  getSources(): Cb2CompiledRuntimeSources | null {
    return this.sources;
  }

  clear(): void {
    this.sources = null;
  }
}
